module.exports = __webpack_public_path__ + "fonts/NespressoLucas-LightItalic.svg?v=8d039f592c7985f4c698d81974c343b7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-LightItalic.svg
// module id = 632
// module chunks = 0